/** GUID vazio em qualquer das formas que a API pode devolver. */
const EMPTY_GUID_RE = /^0{8}-?0{4}-?0{4}-?0{4}-?0{12}$/;

/**
 * `true` para `null`, `undefined`, string vazia ou GUID todo zerado
 * (`00000000-0000-0000-0000-000000000000`).
 */
export function isEmptyGuid(value: string | null | undefined): boolean {
  return !value || EMPTY_GUID_RE.test(value.trim());
}
